<template>
  <div class="select_dialog_embed">
    <div class="supplier_binding_embed_msg">
      <div class="select_dialog_embed_box" :class="{'select_dialog_embed_box_490': showType === 'removeBinding'}">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--绑定供应商-->
          <div v-if="showType === 'bindingSupplier'" class="select_dialog_embed_box_handle">
            <div>
              <label>登录账号：</label>
              <input type="text" title="登录账号" v-model="bindingNum">
            </div>
            <div>
              <label>登录密码：</label>
              <input type="password" title="登录密码" v-model="bindingPwd">
            </div>
          </div>

          <!--解除绑定-->
          <div v-if="showType === 'removeBinding'" class="select_dialog_embed_box_handle" style="width: 100%">
            <div style="margin-bottom: 40px">
              请确定是否要解除供应商绑定，解除后该供应商渠道供货价将进行佣金加点！
            </div>
          </div>

        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom">
          <button class="btn_normal" @click="submitBtn()">提交</button>
          <button class="btn_cancel" @click="cancelBtn(false)">取消</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';

  export default {
    name: 'supplier-binding-embed-msg',
    /**
     *  showType: bindingSupplier=绑定供应商  removeBinding=解除绑定
     *  supplierMsg: 供应商信息
     * */
    props: ['title', 'showType', 'supplierMsg'],
    components: {MsgDialog},
    data() {
      return {
        bindingId: '', // 绑定供应商id
        bindingNum: '', // 绑定供应商账号
        bindingPwd: '', // 绑定供应商密码
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        time: 3, // 倒计时时间
        timer: null // 计时器
      }
    },
    methods: {
      // 接受每个组件传送过来的数据
      componentsCancel(e) {
        console.log(e);
        this.cancelBtn(false);
      },

      // 绑定供应商
      binDingSupplierNum() {
        if (!this.bindingNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入登录账号';
        } else if (!this.bindingPwd) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入登录密码';
        } else {
          // this.cancelBtn(null);
          this.$axios.post(this.Global.saveBindSupplier(this.bindingNum, this.bindingPwd), null).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        }
      },

      // 供应端解除绑定
      relieveSupplierBind() {
        this.$axios.post(this.Global.relieveSupplierBind, null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'bindingSupplier') { // 绑定供应商
          this.binDingSupplierNum();
        } else if (this.showType === 'removeBinding') { // 解除供应商绑定
          this.relieveSupplierBind();
        } else {
          this.cancelBtn(true);
        }

        // 计时器
        this.time = 3;
        const self = this;
        this.timer = setInterval(function () {
          self.time = --self.time;
          if (self.time < 1) {
            self.isMsg = false;
            clearInterval(self.timer);
          }
        }, 1000);
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/supplier-binding-embed-msg.vue